export default function setTokenToStorage(
  storageKey: string,
  {
    accessKey,
    jwtToken,
  }: {
    accessKey: string;
    jwtToken: string;
  },
) {
  const now = new Date();
  const ttl = 24 * 3600 * 1000; // 1 day

  const data = {
    expireTime: now.getTime() + ttl,
    accessKey,
    jwtToken,
  };

  localStorage.setItem(storageKey, JSON.stringify(data));
}
